// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

//scroll anchor links under the header
$(document).ready( function() {
    if(window.location.hash){
        var $target = $(window.location.hash)
        var headerHeight = $('header').height()
        if($target.length > 0) {
            $('html, body').animate({scrollTop: $target.offset().top - headerHeight } , 400);
        }
    }
    $(document).on('click', 'a[href*="#"]:not(.slicknav_btn)', function(e) {
        e.preventDefault();
        var href = $(this).attr("href");
        let current_url = window.location.href.split('#')[0];
        if( ( href.startsWith("#") || href.startsWith(current_url + "#") ) && href !== '#' ) {
            var target = href.split("#")[1]
            if( $('#' + target).length > 0 ) {
                var headerHeight = $('header').height()
                $('html, body').animate({scrollTop: $('#' + target).offset().top - headerHeight } , 400);
            }
        } else {
            window.location.href = href;
        }
    })
})